import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Development SDK
const DevConfig = {
  apiKey: "AIzaSyDoG4eWlZpyV4bUijIbWZWEgwuw60f6fEE",
  authDomain: "localcards-dev.firebaseapp.com",
  databaseURL: "https://localcards-dev.firebaseio.com",
  projectId: "localcards-dev",
  storageBucket: "localcards-dev.appspot.com",
  messagingSenderId: "974634530742",
  appId: "1:974634530742:web:b3e410acc5356eab807317",
  measurementId: "G-W6HW1EW9KG",
};

// Production SDK
export const ProdConfig = {
  apiKey: "AIzaSyCzBvvpxEqQbHhmmzZ969vWfUIbXP6d6qU",
  authDomain: "localcards-prod.firebaseapp.com",
  databaseURL: "https://localcards-prod.firebaseio.com",
  projectId: "localcards-prod",
  storageBucket: "localcards-prod.appspot.com",
  messagingSenderId: "581213466022",
  appId: "1:581213466022:web:45c172082b7820922bf367",
  measurementId: "G-MW0M8PKZW1",
};

// Initialize Firebase app
let app;
if (
  window.location.hostname === "localpoker.info" ||
  window.location.hostname === "www.localpoker.info"
) {
  app = initializeApp(ProdConfig);
} else {
  app = initializeApp(DevConfig);
}

// Initialize Firebase services
const storage = getStorage(app);
let db = getFirestore(app);
const auth = getAuth(app);
const firefuncs = getFunctions(app, "us-central1");
const analytics = getAnalytics(app);

// Emulator setup for localhost
if (
  window.location.hostname === "localhost" &&
  process.env.USE_EMULATORS === "true"
) {
  connectFirestoreEmulator(db, "localhost", 8080);
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFunctionsEmulator(firefuncs, "localhost", 5001);
}

export { storage, db, auth, firefuncs, analytics, app as firebase };

// Default export for backward compatibility
export default app;
